import { MessageFilter, MessageFilterState, MessagePagination } from './messaging.types';

export const DEFAULT_LIMIT = 30;
export const DEFAULT_OFFSET = 0;

export interface MessagingStoreState {
  // Pagination & filters — mutable UI state
  pagination: MessagePagination;
  filter: MessageFilter;
  availableStates: MessageFilterState[];

  // Active thread
  activePatientId: number | null;

  // Chat lock
  lockPatientId: number | null;
}

export const initialState: MessagingStoreState = {
  pagination: {
    limit: DEFAULT_LIMIT,
    offset: DEFAULT_OFFSET,
    total: 0,
    category_id: 0,
    order: 'desc',
    read: 'false',
    state: [],
  },

  filter: {
    categoryId: 0,
    read: 'false',
    order: 'desc',
    states: [],
    savedSearch: false,
  },
  availableStates: [],

  activePatientId: null,

  lockPatientId: null,
};
